module.exports = __webpack_public_path__ + "img/ic_head_hight_7.6c854b50.png";